import React from 'react';

export default function Logout() {
    localStorage.removeItem('trc-pro-client-token');
    window.location.href="/";

    return(
        <h2>Déconnexion</h2>
    );
}